
class LazyComponent
{
	constructor(rootNode, { url } = {})
	{
		this.rootNode = rootNode;
		this.url = url || location.href;

		this.#observe();
	}

	load()
	{
		const url = BX.Uri.addParam(this.url, {
			comp_id: this.rootNode.id
		});

		gov.utils.ajax.insertToNode(
			this.rootNode,
			url
		);
	}

	async #observe()
	{
		const options = {
			rootMargin: '20% 0% 20% 0%',
			threshold: 0.3
		};

		if (!('IntersectionObserver' in window))
			await BX.Runtime.loadExtension('main.polyfill.intersectionobserver');

		this.observer = new IntersectionObserver(this.#onIntersection.bind(this), options);
		this.observer.observe(this.rootNode);
	}

	#onIntersection(entries)
	{
		const entry = entries.find(({ target }) => target === this.rootNode);
		if (entry?.isIntersecting)
		{
			this.observer.unobserve(this.rootNode);
			this.load();
		}
	}
}

export { LazyComponent };